import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useLoadSavedCalculation = ({ URL, loadOneCalculation, calculate, setInputs, showMuiSnack }) => {
  const location = useLocation();
  const loadedFromQueryRef = useRef(null);

  useEffect(() => {
    const savedId = new URLSearchParams(location.search).get('saved');
    if (!savedId || loadedFromQueryRef.current === savedId) return;

    const loadFromQuery = async () => {
      try {
        loadedFromQueryRef.current = savedId;
        const loadedParams = await loadOneCalculation(savedId, URL.LOADONE);
        setInputs(loadedParams);
        await calculate(loadedParams, URL.CALCULATE);
      } catch (err) {
        showMuiSnack('Failed to load saved calculation.', 'error');
      }
    };

    loadFromQuery();
  }, [location.search, URL, loadOneCalculation, calculate, setInputs, showMuiSnack]);
};

export default useLoadSavedCalculation;
